const FailIcon = ({ width, height }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width ?? height ?? 15}
            height={height ?? 15}
            viewBox="0 0 24 24"
        >
            <g fill="none">
                <path
                    fill="url(#IconifyId1959b769955fd9ffe0)"
                    d="M9.666 11.49L6.324 4.571h4.837l1.701 4.053h.043l3.112-4.053H21l-5.994 7.21l3.553 7.647h-5.003l-1.83-4.655h-.042L8.13 19.43H3z"
                />
                <defs>
                    <linearGradient
                        id="IconifyId1959b769955fd9ffe0"
                        x1="11.999"
                        x2="11.999"
                        y1="19.429"
                        y2="4.57"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset=".015" stopColor="#FD6422" />
                        <stop offset=".26" stopColor="#FC194A" />
                        <stop offset=".605" stopColor="#FC125F" />
                        <stop offset="1" stopColor="#9B2AA6" />
                    </linearGradient>
                </defs>
            </g>
        </svg>
    );
};

export default FailIcon;
